import React, { Component } from 'react'
import ReactTable from "react-table"
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import ReactJson from 'react-json-view'

import { tableColumnHelper } from './Utils'

class SesamRequestsTable extends Component {
    constructor(p) {
        super(p)

        this.state = { enteredCellIndex: null }

    }

    renderTransformedResult = (t) => {
        return t.map((field, i) => {
            return (
                <div key={i}>
                    <p><b>{field.label}</b>: {typeof field.value !== "string" ? <ReactJson collapsed={field.collapsed || false} displayDataTypes={false} name={false} displayObjectSize={false} src={field.value} /> : field.value}</p>
                </div>
            )
        })
    }

    renderCell = (payload) => {
        return JSON.stringify(payload)
    }

    renderInnerText = (direction, obj) => {
        if (direction === "request") return <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={obj.payload} />

        return <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={obj.response || {}} />
    }


    defaultFilterMethod = (filter, data) => {
        if (!data) return false

        return JSON.stringify(data).toLowerCase().indexOf(filter.value.toLowerCase()) > -1
    }

    render() {
        const { sesamRequests = [], requestName, locks } = this.props

        const tableColumns = tableColumnHelper(this, requestName)

        return (
            <Grid fluid>
                <Row>
                    <Col xs={12} md={12} lg={12}>

                        <h4>Antal: {sesamRequests.length}</h4>

                        <ReactTable
                            data={sesamRequests}
                            filterable
                            columns={tableColumns}
                            NoDataComponent={props => (null)}
                            showPagination={true}
                            showPageSizeOptions={false}
                            loading={!sesamRequests.length || !locks}
                            loadingText="Laddar..."
                            pageSize={sesamRequests.length > 30 ? 30 : sesamRequests.length}
                            className="-striped -highlight"
                            // SubComponent={(o) => { const document = o.original; return <div style={{ padding: 10 }}>{JSON.stringify(document.payload)}</div> }}
                            defaultFilterMethod={(filter, row) => {
                                const id = filter.pivotId || filter.id
                                return row[id] !== undefined ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true
                            }}
                        />
                    </Col>
                </Row>
            </Grid>
        )
    }
}

const mapProps = state => {
    return {
        locks: state.collectionData.locks,
        sesamLockDescriptions: state.dataAnalytics.sesamLockDescriptions,
    }
}

const mapDispatch = dispatch => {
    return {}
}

export default connect(mapProps, mapDispatch)(SesamRequestsTable)
